import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { RestService } from '../rest/rest.service';
import { Message, Messages } from '../../domain/messages.domain';

@Injectable({
  providedIn: 'root'
})
export class MessagesRestService {
  private readonly restService = inject(RestService);

  retrieveMessages(params: Record<string, unknown>): Observable<Messages> {
    return this.restService.getResource('customer.messages').get({ params });
  }

  markAsRead(messages: Array<Message>): Observable<boolean> {
    return this.restService.getResource('customer.markAsRead').put({ messages });
  }
}
